var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isIframe
    ? _c(
        "v-card",
        [
          _c(
            "v-navigation-drawer",
            {
              attrs: {
                id: "core-navigation-drawer",
                dark: true,
                app: "",
                left: "",
                "mini-variant-width": "80",
                width: "260"
              },
              model: {
                value: _vm.drawer,
                callback: function($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer"
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.isIframe) + " "),
              _c(
                "v-list-item",
                { attrs: { "one-line": "" } },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _c("span", { staticClass: "logo-normal" }, [
                          _c("img", {
                            attrs: {
                              id: "body-swaps-logo",
                              src: require("@/assets/Bodyswaps_WO.svg")
                            }
                          })
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-list",
                { attrs: { expand: "", nav: "" } },
                [
                  _c("div"),
                  _vm._l(_vm.items, function(item, i) {
                    return [
                      item.children && _vm.isItemAuthorisedForRole(item)
                        ? _c("base-item-group", {
                            key: "group-" + i,
                            attrs: {
                              item: Object.assign({}, item, {
                                title: _vm.$t(item.title)
                              })
                            }
                          })
                        : _vm._e(),
                      !item.children && _vm.isItemAuthorisedForRole(item)
                        ? _c("base-item", {
                            key: "item-" + i,
                            attrs: {
                              item: Object.assign({}, item, {
                                title: _vm.$t(item.title)
                              })
                            }
                          })
                        : _vm._e()
                    ]
                  }),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        href: "https://support.bodyswaps.co/knowledge",
                        target: "_blank"
                      }
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-help-circle")])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("nav.knowledge-center")) + " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.notLearner
                    ? _c(
                        "v-list-item",
                        {
                          attrs: {
                            href: "https://support.bodyswaps.co/",
                            target: "_blank"
                          }
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("mdi-bookshelf")])],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("nav.community-portal")) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        href: "https://bodyswaps.co/request-support",
                        target: "_blank"
                      }
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-alert")])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("nav.request-support")) + " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    {
                      attrs: {
                        href: "https://bodyswaps.co/referral-programme",
                        target: "_blank"
                      }
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-handshake")])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("nav.referral-programme")) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._l(_vm.locales, function(item, i) {
                    return _c(
                      "v-list-item",
                      {
                        key: "locales-" + i,
                        staticClass: "d-lg-none d-xl-flex spacing-mobile"
                      },
                      [
                        _c(
                          "v-list-group",
                          {
                            staticStyle: { width: "255px !important" },
                            attrs: { value: item.isActive },
                            on: {
                              input: function($event) {
                                item.isActive = !item.isActive
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("v-icon", [
                                            _vm._v(_vm._s(item.title))
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("nav.localise")) +
                                          " "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          _vm._l(item.subItems, function(subItem, j) {
                            return _c(
                              "v-list-item",
                              {
                                key: j,
                                staticStyle: { "margin-left": "25px" },
                                on: {
                                  click: function($event) {
                                    return _vm.changeLocale(subItem)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(subItem.name) + " ")]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._l(_vm.accounts, function(item, index) {
                    return _c(
                      "v-list-item",
                      {
                        key: "accounts-" + index,
                        staticClass: "d-lg-none d-xl-flex spacing-mobile"
                      },
                      [
                        _c(
                          "v-list-group",
                          {
                            staticStyle: { width: "255px !important" },
                            attrs: { value: item.isActive },
                            on: {
                              input: function($event) {
                                item.isActive = !item.isActive
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("v-icon", [
                                            _vm._v(_vm._s(item.title))
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("nav.profile")) +
                                          " "
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._l(Object.entries(_vm.profiles), function(ref) {
                              var key = ref[0]
                              var profile = ref[1]
                              return _c(
                                "v-list-item",
                                {
                                  key: key,
                                  staticClass: "pa-0",
                                  staticStyle: { "margin-left": "25px" },
                                  attrs: { disabled: _vm.isActiveProfile(key) },
                                  on: {
                                    click: function($event) {
                                      return _vm.setProfile(key)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(profile.account.displayName) +
                                      " "
                                  )
                                ]
                              )
                            }),
                            _c(
                              "v-list-item",
                              {
                                staticStyle: { "margin-left": "25px" },
                                on: { click: _vm.logout }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.logout")) + " "
                                )
                              ]
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  }),
                  _c("div")
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.drawer,
                  expression: "!drawer"
                }
              ]
            },
            [
              _c(
                "v-app-bar",
                { attrs: { app: "" } },
                [
                  _c("v-app-bar-nav-icon", {
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.drawer = !_vm.drawer
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }